module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "media-list"
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/grant'
      }
    }
  }, [_vm._v("授权课程")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("课程详情")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main-box"
  }, [_c('Card', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('div', {
    staticClass: "panel-box"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("课包基本信息")]), _vm._v(" "), _c('div', {
    staticClass: "panel-content"
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.showPkg,
      "label-width": "90px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "课包名称:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.name))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课包ID:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.id))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.level))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "封面:"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.showPkg.image,
      "width": "80px",
      "height": "80px"
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "周期:"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.showPkg.period) + "课程")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "课程类型:"
    }
  }, [_c('span', [_vm._v("体系课")])]), _vm._v(" "), _c('br')], 1)], 1)])]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "stripe": "",
      "tooltip-effect": "dark",
      "data": _vm.detailData
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "appId",
      "label": "机构ID",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "name",
      "label": "机构名称",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "authInfo",
      "label": "到期时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.authInfo.length != 0) ? _c('span', [_vm._v("\n        " + _vm._s(_vm._f("formatDate2")(scope.row.authInfo[0])) + " 至 " + _vm._s(_vm._f("formatDate2")(scope.row.authInfo[1])) + "\n      ")]) : _c('span', [_vm._v("已取消授权")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "操作日志"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "操作日志",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "icon": "el-icon-document",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "管理"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.authInfo.length != 0) ? _c('span', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.deleSN(scope.row.appId)
            }
          }
        }, [_vm._v("取消授权")])], 1) : _c('span')]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [10, 20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal1
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2e136d85","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/course/detailAuthorization.vue
// module id = 670
// module chunks = 1